import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import { Tooltip, type SxProps, Typography, Stack } from '@mui/material';

// Marker styles
const markerStyles = {
    position: 'absolute',
    top: '2px', // Adjust vertical position
    width: '2px',
    height: '10px',
    transform: 'translateX(-50%)', // Center the marker on its position
};

interface Marker {
    position: number;
    label: string;
    color: string;
}

export interface LinerBackgroundProgressProps {
    value: number;
    completedColor: string;
    unCompletedColor: string;
    children: React.ReactNode
}

function LinerBackgroundProgress({ value, children, completedColor, unCompletedColor }: LinerBackgroundProgressProps) {
    const cappedValue = Math.min(100, value);
    return (
        <Box sx={{ position: 'relative', paddingX: 1, paddingY:0.5, width: '100%', minHeight:'40px'}}>
            <Stack direction="row" alignItems="center" spacing={0} sx={{ position:'absolute',top:0,left:0, display: 'inline-flex', flexWrap: 'nowrap', width: '100%', minHeight:'40px' }}>
                <Box sx={{ width: `${cappedValue}%`, backgroundColor: completedColor, minHeight: '40px', borderTopLeftRadius: '5px', borderBottomLeftRadius: '5px', borderRight:`3px solid ${completedColor}` }}>
                </Box>
                <Box sx={{ width: `${100 - cappedValue}%`,backgroundColor: unCompletedColor, minHeight: '40px', borderTopRightRadius: '5px', borderBottomRightRadius: '5px' }}>
                </Box>
            </Stack>
            {children}
        </Box>
    );
}

export default LinerBackgroundProgress;